import { useLocation } from 'react-router-dom';

export function useQueryUrl() {
  return new URLSearchParams(useLocation().search);
}
